var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRoundButton = function SvgArrowRoundButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5993EA",
    d: "M20 .5C30.77.5 39.5 9.23 39.5 20S30.77 39.5 20 39.5.5 30.77.5 20 9.23.5 20 .5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5993EA",
    d: "M12.5 19.964a.5.5 0 0 1 .5-.5h12.757l-3.397-3.396a.5.5 0 1 1 .707-.707l4.163 4.162c.16.083.27.248.27.441l-.002.018a.495.495 0 0 1-.145.372l-4.286 4.285a.5.5 0 1 1-.707-.707l3.468-3.468H13a.5.5 0 0 1-.5-.5Z"
  })));
};
export default SvgArrowRoundButton;